import "./NavCursada.css"
import Calif from "../../../../assets/iconos/sub-cursada/calificaciones.svg"
import Inicio from "../../../../assets/iconos/sub-cursada/inicio.a.svg"
import Modulos from "../../../../assets/iconos/sub-cursada/modulos.svg"
import HamburguerM from '../../../../assets/iconos/burguermenu.svg'

import { useState, useRef, useEffect } from "react"


var subFrame = null;
export default function NavCursada(props) {

    const handleClickOut = () => {
    }


    useEffect(() => {
        const handleHideNav = (e) => {
            // if (e.target !== menuRef.current && e.target !== imgRef.current) {
            //     setOpen(false);
            // }
        }

        window.addEventListener("click", handleHideNav);

        return () => {
            window.removeEventListener("click", handleHideNav);
        }
    }, []);



    const [open, setOpen] = useState(false);

    return (
        <div>
            <div className={"nav-user-button"}
                onClick={() => setOpen(!open)}>
                <img src={HamburguerM} alt="menu" className={!open ? "icon-cursada setpointer" : "icon-cursada icon-cursada2 setpointer"} />
            </div>
            {
                open && (
                    <div className="navCursadaContainer box" onBlur={handleClickOut}>
                        <div to="inicio " onClick={() => props.setSubFrame('inicio')} >
                            <div className='cursada-item '>
                                <img src={Inicio} alt="inicio" className="icon" />
                                <p className='cursada-item'>Inicio</p>
                            </div>
                        </div>
                        <div to="modulos" className='cursada-item' onClick={() => props.setSubFrame('modulos')}>
                            <div className='cursada-item '>
                                <img src={Modulos} alt="modulos" className="icon" />
                                <p className='cursada-item '>Modulos</p>
                            </div>
                        </div>
                        <div to="calificaciones" className='cursada-item' onClick={() => props.setSubFrame('calificaciones')}>
                            <div className='cursada-item '>
                                <img src={Calif} alt="calificaciones" className="icon" />
                                <p className='cursada-item '>Calificaciones</p>
                            </div>
                        </div>
                    </div>
                )}
        </div>
    );
}